import { SelectionChangedEvent } from "ag-grid-community";
import { BankerEntity } from "domain/entity/Banker/BankerEntity";
import { INITIAL_BANKER_COL_DEF, transferRowData } from "presentation/constant/Banker/BankerColumnDefinition";
import { BankerConstant } from "presentation/constant/Banker/BankerConstant";
import { useBankerVM } from "presentation/hook/Banker/useBankerVM";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useBankerTracked } from "presentation/store/Banker/BankerProvider";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useMemo, useRef } from "react";

const BankerTablePanel: React.FC = () => {
    const [bankerState] = useBankerTracked();
    const bankerVM = useBankerVM();
    const { bankerList } = bankerState;
    const gridRef: any = useRef(null);
    const [anaInfoState] = useANAInfoTracked();
    const { allowCreate } = anaInfoState;

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        const selectedRows = e.api.getSelectedRows();
        bankerVM.updateSelectedRows(selectedRows);
    }, [bankerVM])

    const handleRowDoubleClick = useCallback((entity: BankerEntity) => {
        bankerVM.onRowDoubleClick(entity);
    }, [bankerVM])

    const handleAdd = useCallback(() => {
        bankerVM.onAddClick();
    }, [bankerVM]);

    const memoTable = useMemo(() => {
        return (
            <NbisTable
                id='banker-table'
                isNewColumnSetting={true}
                headerLabel={BankerConstant.TITLE}
                columns={INITIAL_BANKER_COL_DEF}
                data={transferRowData(bankerList ?? [])}
                showPaginator={false}
                editable={false}
                showAddIcon={allowCreate}
                onAddClick={handleAdd}
                showDeleteButton={false}
                showReloadIcon={false}
                isScrollHighlighted={true}
                selectionMode={false}
                isRowHighligted={true}
                handleSelectionChanged={handleSelectionChange}
                onRowDoubleClick={(e: any, entity: BankerEntity) => handleRowDoubleClick(entity)}
                gridHeight="customHeight"
                customHeight="calc(100vh - 75px)"
                ref={gridRef}
            />
        );
    }, [bankerList, allowCreate, handleAdd, handleSelectionChange, handleRowDoubleClick])

    return <><TableWrapper>
        {memoTable}
    </TableWrapper>
    </>;
}

export default memo(BankerTablePanel);
